import { useMemo, type FC } from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';

import { useAppTheme } from '@/styles/hooks/useAppTheme';
import type { AppTheme } from '@/styles/theme';

const makeStyles = (theme: AppTheme) =>
  StyleSheet.create({
    container: { paddingHorizontal: 32 },
    paragraph: {
      fontSize: 16,
      lineHeight: 24,
      letterSpacing: 0.5,
      color: theme.colors.onSurface,
      paddingBottom: 8
    }
  });

export const TerritorialAuthorityDescription: FC<{
  description: string | undefined;
}> = ({ description }) => {
  const theme = useAppTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);

  const paragraphs = useMemo(
    () => (description ?? '').split(/\n\s*\n/).filter((p) => p.length > 0),
    [description]
  );

  if (paragraphs.length === 0) {
    return <></>;
  }

  return (
    <View style={styles.container}>
      {paragraphs.map((para) => (
        <Text key={para} style={styles.paragraph}>
          {para}
        </Text>
      ))}
    </View>
  );
};
